import type { Movie } from '@filmsloth/shared';
import { useMovieTitle } from '../i18n/index.js';
import { coverGradient } from '../lib/cover.js';

export function Poster({ movie, size = 'lg' }: { movie: Movie; size?: 'sm' | 'lg' }) {
  const movieTitle = useMovieTitle();
  const className = size === 'sm' ? 'poster poster--sm' : 'poster';

  if (movie.posterUrl) {
    return (
      <div className={className}>
        <img
          className="poster__image"
          src={movie.posterUrl}
          alt={movieTitle(movie)}
          loading="lazy"
        />
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="poster__fallback" style={{ background: coverGradient(movie.id) }}>
        <span className="poster__fallback-title">{movieTitle(movie)}</span>
        {size === 'lg' && movie.year !== null && <span className="small muted">{movie.year}</span>}
      </div>
    </div>
  );
}
